import axios from "axios";

// Create an instance of axios
const api = axios.create({
  baseURL: "https://dispatch.gologanairport.com/",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Create a separate instance for payment requests to handle CORS properly
export const paymentApi = axios.create({
  baseURL: "https://dispatch.gologanairport.com/",
  timeout: 30000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
    "Accept": "application/json",
  },
});

// Interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API call failed:", error);
    return Promise.reject(error);
  }
);

export default api;
